import { render, staticRenderFns } from "./TraysFilters.vue?vue&type=template&id=7c70d5e7&"
import script from "./TraysFilters.vue?vue&type=script&lang=js&"
export * from "./TraysFilters.vue?vue&type=script&lang=js&"
import style0 from "./TraysFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c70d5e7')) {
      api.createRecord('7c70d5e7', component.options)
    } else {
      api.reload('7c70d5e7', component.options)
    }
    module.hot.accept("./TraysFilters.vue?vue&type=template&id=7c70d5e7&", function () {
      api.rerender('7c70d5e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/TraysFilters.vue"
export default component.exports